import { QueryClientProvider } from "@tanstack/react-query";
import { PostHogProvider } from "posthog-js/react";
import { posthogApiKey, posthogOptions } from "../config/env";
import { queryClient } from "@/lib/query-client";

export function Provider({ children }: { children: React.ReactNode }) {
  return (
    <PostHogProvider apiKey={posthogApiKey} options={posthogOptions}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </PostHogProvider>
  );
}
